import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Typography, { FontWeights } from 'builder/styles/typography'
import Media from 'builder/styles/media'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const MobileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
  display: none;

  ${Media.Phone`
    display: flex;
  `};
`

export const RatingContainerVertical = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const RatingContainerHorizontal = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0 auto;
`

export const Rating = styled.p<{ $useMargin: boolean }>`
  ${Typography.Body};
  ${FontWeights.DemiBold};
  color: ${Colors.Neutral100};

  ${props => props.$useMargin && 'margin-top: 12px;'}
`

export const RatingNumberHorizontal = styled.p`
  ${Typography.Tiny};
  color: ${Colors.Neutral90};

  ${Media.Phone`
    display: none;
  `};
`

export const RatingNumberHorizontalMobile = styled.p`
  ${Typography.Tiny};
  color: ${Colors.Neutral90};
  gap: 4px;
`

export const RatingNumberVertical = styled.p`
  ${Typography.Tiny};
  color: ${Colors.Neutral50};
  margin-bottom: 8px;
`

export const StarImage = styled.img`
  width: 24px;
  height 24px;
`

export const Logo = styled.img`
  height: 22px;
  width: 88px;

  ${Media.Phone`
    display: none;
  `};
`

export const LogoMobile = styled.img`
  height: 26px;
  width: 106px;
`
